export default "__VITE_ASSET__D7AY8xFM__"